module.exports = __webpack_public_path__ + "img/alipayLogo.cf6e229f.png";